if (!customElements.get('card-slider')) {

  class CardSlider extends HTMLElement {

    constructor() {
      super();

      this.currentIndex = 0;
      this.sliderTrack = null;
      this.slides = [];

      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      this.swiperOptions =
        JSON.parse(this.getAttribute('data-swiper-options')) || {};

      this.initSlider();

      window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
    }

    handleResize() {
      this.updateSlider();
    }

    initSlider() {

      this.sliderTrack =
        this.querySelector('.swiper-wrapper') || this;

      this.slides = Array.from(this.sliderTrack.children);

      if (!this.slides.length) return;

      this.setupStructure();
      this.setupNavigation();
      this.updateSlider();
    }

    setupStructure() {

      this.style.overflow = 'hidden';

      this.sliderTrack.style.display = 'flex';
      this.sliderTrack.style.transition = 'transform 0.4s ease';
      this.sliderTrack.style.willChange = 'transform';

    }

    setupNavigation() {

      const nextBtn = this.querySelector('.swiper-button--next');
      const prevBtn = this.querySelector('.swiper-button--prev');

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          this.nextSlide();
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          this.prevSlide();
        });
      }

    }

    updateSlider() {

      const width = window.innerWidth;

      let slidesPerView = 1;
      let gap = this.swiperOptions.spaceBetweenMobile || 2;

      const isArticlesSlider =
        this.classList.contains('js-articles');

      const isTestimonials =
        this.classList.contains('js-testimonials');

      if (isTestimonials) {

        if (width < mobileWidth) {

          slidesPerView = width >= 480 ? 2 : 1;
          gap = 4;

        } else {

          slidesPerView = 1;
          gap = 0;

        }

      } else {

        if (width >= 750) {
          slidesPerView = 3;
          gap = this.swiperOptions.spaceBetweenDesktop || 2;
        } else if (isArticlesSlider && width >= 575) {
          slidesPerView = 2;
        }

      }

      this.slidesPerView = slidesPerView;
      this.gap = gap;

      const slideWidth =
        `calc((100% - ${(slidesPerView - 1) * gap}px) / ${slidesPerView})`;

      this.slides.forEach(slide => {
        slide.style.flex = `0 0 ${slideWidth}`;
        slide.style.marginRight = `${gap}px`;
      });

      this.goToSlide(this.currentIndex);

    }

    goToSlide(index) {

      const maxIndex =
        Math.max(this.slides.length - this.slidesPerView, 0);

      this.currentIndex =
        Math.max(0, Math.min(index, maxIndex));

      const firstSlide = this.slides[0];

      if (!firstSlide) return;

      const slideWidth =
        firstSlide.offsetWidth + this.gap;

      this.sliderTrack.style.transform =
        `translateX(-${this.currentIndex * slideWidth}px)`;

    }

    nextSlide() {
      this.goToSlide(this.currentIndex + 1);
    }

    prevSlide() {
      this.goToSlide(this.currentIndex - 1);
    }

  }

  customElements.define('card-slider', CardSlider);

}